import type { ChatRoom } from "@/react/types/Chat/ChatRoom";

export const onChatMarkAllAsRead = (
  eventData: any,
  chatRooms: any[],
  updateQueryCache: (updatedChatRooms: ChatRoom[]) => void,
) => {
  const { chat_room_uuids: chatRoomUuids = [] } = eventData;
  if (chatRoomUuids.length === 0) return;
  const updatedChatRooms = chatRooms.map((chatRoom: ChatRoom) => {
    if (chatRoomUuids.includes(chatRoom.uuid)) {
      return { ...chatRoom, has_unread_messages: false };
    }
    return chatRoom;
  });
  updateQueryCache(updatedChatRooms);
};

export const onChatRoomRead = (
  eventData: any,
  chatRooms: any[],
  updateQueryCache: (updatedChatRooms: ChatRoom[]) => void,
) => {
  const { chat_room_uuid } = eventData;
  const chatRoomIndex = chatRooms.findIndex(
    chatRoom => chatRoom.uuid === chat_room_uuid,
  );
  if (chatRoomIndex > -1) {
    const messageChatRoom = chatRooms[chatRoomIndex];
    const updatedChatRooms = [
      ...chatRooms.slice(0, chatRoomIndex),
      { ...messageChatRoom, has_unread_messages: false },
      ...chatRooms.slice(Number(chatRoomIndex) + 1),
    ];
    updateQueryCache(updatedChatRooms);
  }
};
